import * as yup from 'yup';

export const FIELD_TITLE = 'title';
export const FIELD_TITLE_RU = 'title.ru';
export const FIELD_TITLE_UZ = 'title.uz';
export const FIELD_TITLE_OZ = 'title.oz';
export const FIELD_ADDRESS = 'address';
export const FIELD_ADDRESS_RU = 'address.ru';
export const FIELD_ADDRESS_UZ = 'address.uz';
export const FIELD_ADDRESS_OZ = 'address.oz';
export const FIELD_PHONE = 'phone';
export const FIELD_EMAIL = 'email';
export const FIELD_STIR = 'stir';

export const OrganizationsEditValidationForm = yup.object().shape({
  [FIELD_TITLE_RU]: yup.string().trim(),
  [FIELD_TITLE_UZ]: yup.string().trim(),
  [FIELD_TITLE_OZ]: yup.string().trim(),
  [FIELD_ADDRESS_RU]: yup.string().trim(),
  [FIELD_ADDRESS_UZ]: yup.string().trim(),
  [FIELD_ADDRESS_OZ]: yup.string().trim(),
  [FIELD_PHONE]: yup
    .string()
    .transform((value) => value.replace(/\s/g, ''))
    .length(13, 'error.phoneFormat')
    .required('error.required'),
  [FIELD_EMAIL]: yup.string().email('error.email').required('error.required').trim(),
  [FIELD_STIR]: yup.string().length(9, 'error.stirLen').required('error.required').trim(),
});
